import React from 'react';

const ArticleItem = ({ article }) => {
  return (
    <div>
      <h3>{article.name}</h3>
      <p>Prix: {article.price} €</p>
      <p>{article.description}</p>
    </div>
  );
};

export default ArticleItem;
